/**
 * POST /connection/execute/{appId}/{connectionId} runs an external API on
 * behalf of an app. Automy forwards the upstream HTTP status, so a 401/403
 * from Nominatim (or any other provider) arrives as a 401/403 of this route.
 *
 * That status is an operation failure. It is not an Automy session expiry
 * or a missing permission. The auth interceptor must not abort the global
 * request controller or replace the route with /exception/403, which ejects
 * the user from the app builder.
 */
export const isConnectionExecuteUrl = (...candidates) =>
  candidates.some((url) => {
    if (!url || typeof url !== 'string') return false;
    const path = url.split('?')[0];
    return path.includes('/connection/execute/');
  });

export const isProxiedConnectionAuthStatus = (status, ...candidates) =>
  (status === 401 || status === 403) && isConnectionExecuteUrl(...candidates);
